import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { SectionMenu, SectionMenuItem } from 'uikit/layout'

import { Catalog } from './Catalog'
import { RewardDistribution } from './RewardDistribution'
import { Settings } from './Settings'
import { Transfer } from './Transfer'

export const Referral = () => {
  const match = useRouteMatch()

  return (
    <>
      <SectionMenu>
        <SectionMenuItem colorPalette="teal" to="/referral/catalog">
          Каталог событий
        </SectionMenuItem>
        <SectionMenuItem colorPalette="teal" to="/referral/transfer">
          Переводы
        </SectionMenuItem>
        <SectionMenuItem colorPalette="teal" to="/referral/settings">
          Настройки
        </SectionMenuItem>
        <SectionMenuItem colorPalette="teal" to="/referral/rewardDistribution">
          Назначение наград
        </SectionMenuItem>
      </SectionMenu>
      <Switch>
        <Route path={`${match.url}/catalog`}>
          <Catalog />
        </Route>
        <Route path={`${match.url}/transfer`}>
          <Transfer />
        </Route>
        <Route path={`${match.url}/settings`}>
          <Settings />
        </Route>
        <Route path={`${match.url}/rewardDistribution`}>
          <RewardDistribution />
        </Route>
      </Switch>
    </>
  )
}
